<div class="container">
  <div class="navigate-chips">
    <div matRipple class="order-chips" [routerLink]="['/thesis-binding']">
      <h3>سفارش پایان‌نامه</h3>
    </div>
    <div matRipple class="order-chips" routerLink="/thesis-editing" [routerLinkActive]="['active']" [routerLinkActiveOptions]="{ exact: true }"><h3>ویرایش پایان‌نامه</h3></div>
  </div>
  <div class="print-order-container" @fadeInOut>
    <mat-card class="print-order-card">
      <mat-card-title class="title button-container">
        <div (click)="startHelp()" class="help" fxLayout="row" fxLayoutAlign="flex-end center">
          <span> راهنما </span>
          <div class="help-icon" fxLayout="center" fxLayoutAlign="center">؟</div>
        </div>
      </mat-card-title>
      <!-- Mat card content -->
      <mat-card-content>
        <!-- Select document file -->
        <div
          class="block select-files"
          id="filesSelect"
          fxLayout="column"
          fxLayoutAlign="start space-around"
        >
          <!-- Upload First user -->
          <div class="wrapper" fxLayout="column">
            <shared-file-placeholder
              [immediateUpload]="true"
              (onFileSelect)="onDocFileReport($event)"
              fxFlex="48"
              [noPlaceholder]="true"
              [layouts]="[14, 86]"
              uploadButtonTitle="انتخاب فایل مقاله / پایان‌نامه"
              color="warn"
              class="shared-file-placeholder"
              name="main"
              id="thesisFilePlaceholder"
              urlName="upload"
            >
            </shared-file-placeholder>
  
            <shared-file-placeholder
              id="descriptorFilePlaceholder"
              class="shared-file-placeholder"
              name="descriptor"
              color="primary"
              [immediateUpload]="true"
              [fileType]="getValidTypes()"
              (onFileSelect)="onDescriptorUpload($event)"
              [help]="getValidTypesHelp()"
              [acceptableFormats]="['pdf', 'word']"
              fxFlex="48"
              name="descriptor"
              [noPlaceholder]="true"
              [layouts]="[14, 86]"
              urlName="upload"
              uploadButtonTitle="انتخاب فایل فرمت مقاله / پایان‌نامه"
            >
            </shared-file-placeholder>
          </div>
        </div>
  
        <!-- Help  -->
        <div class="block help-text" fxLayout="row" fxLayoutAlign="center center">
          <p fxFlex="100" class="disabled">
            لطفا فایل مربوط به مقاله پایان‌نامه خود را در فرمت PDF یا Word آپلود
            کنید. <br />
            سپس فایل توضیحات و فرمت ارایه شده به دانشجو را آپلود کنید که در آن
            توضیحات مربوط به ... داده شده است. <br />
            اگر توضیحات دیگری در خصوص ویرایش پایان‌نامه دارید آن را در بخش توضیحات
            وارد کنید.
          </p>
        </div>
        <div class="block">
          <form [formGroup]="formGroup">
            <mat-form-field
              id="printOrderExtraInformation"
              class="textarea"
              appearance="outline"
            >
              <mat-label>توضیحات بیشتر</mat-label>
              <textarea
                class="extra-info-textarea"
                formControlName="moreDetails"
                #autosize="cdkTextareaAutosize"
                cdkAutosizeMinRows="10"
                cdkTextareaAutosize
                matInput
                placeholder="توضیحات سفارش ..."
              ></textarea>
            </mat-form-field>

            <div class="block" fxLayout="row">
              <app-submit-btn
                [title]="!editMode ? 'افزودن به سبد خرید' : 'ویرایش سفارش'"
                id="submitBtn"
                fxFlex="49"
                fxFlex.md="100"
                fxFlex.sm="100"
                fxFlex.xs="100"
                [anim-options]="submitAnimationOptions"
                (animationStart)="submit()"
                *ngIf="isHandset$ | async"
                [anim-style]="mobileSubmitAnimationStyle"
              >
              </app-submit-btn>
            </div>
            
          </form>
        </div>
      </mat-card-content>
    </mat-card>
  
    <!-- <div class="spacer" fxFlex="2"></div> -->
  
    <div
      id="copiesInput"
      fxLayout="row wrap"
      fxLayoutAlign="end end"
      fxFlex="40"
      fxFlex.sm="100"
      fxFlex.xs="100"
      *ngIf="!(isHandset$ | async)"
    >
      <app-submit-btn
        [title]="!editMode ? 'افزودن به سبد خرید' : 'ویرایش سفارش'"
        [anim-options]="submitAnimationOptions"
        (animationStart)="submit()"
        fxFlex.md="100"
        fxFlex.sm="100"
        fxFlex.xs="100"
        id="submitBtn"
        fxFlex="76"
      >
      </app-submit-btn>
    </div>
  </div>
</div>
<app-dynamic-content
  *ngIf="printConfigs && printConfigs['why_ziraxi']"
  [config]="printConfigs"
></app-dynamic-content>